import { motion } from 'framer-motion';

// Variantes de animación para Framer Motion
export const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 20 }
};

export const staggerContainer = {
  initial: {},
  animate: {
    transition: {
      staggerChildren: 0.1
    }
  }
};

export const scaleIn = {
  initial: { scale: 0.95, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  exit: { scale: 0.95, opacity: 0 }
};

export const slideInFromLeft = {
  initial: { x: -20, opacity: 0 },
  animate: { x: 0, opacity: 1 },
  exit: { x: -20, opacity: 0 }
};

export const slideInFromRight = {
  initial: { x: 20, opacity: 0 },
  animate: { x: 0, opacity: 1 },
  exit: { x: 20, opacity: 0 }
};

// Clases de animación reutilizables
export const animations = {
  // Animaciones básicas
  fadeIn: "animate-fadeIn",
  slideUp: "animate-slideUp",
  slideDown: "animate-slideDown",
  slideLeft: "animate-slideLeft",
  slideRight: "animate-slideRight",
  scaleUp: "animate-scaleUp",
  bounce: "animate-bounce",
  pulse: "animate-pulse",
  spin: "animate-spin",
  float: "animate-float",
  wiggle: "animate-wiggle",
  
  // Animaciones al hacer scroll
  revealOnScroll: "opacity-0 transition-all duration-700 translate-y-10",
  revealOnScrollVisible: "opacity-100 translate-y-0",
  revealFromLeft: "opacity-0 transition-all duration-700 -translate-x-20",
  revealFromRight: "opacity-0 transition-all duration-700 translate-x-20",
  revealFromLeftVisible: "opacity-100 translate-x-0",
  revealFromRightVisible: "opacity-100 translate-x-0",
  
  // Efectos hover modernos
  cardHover: "transition-all duration-300 hover:scale-[1.02] hover:shadow-lg hover:shadow-primary/10",
  buttonHover: "transition-all duration-300 hover:scale-[1.02] hover:brightness-110 active:scale-95",
  linkHover: "transition-colors duration-200 hover:text-primary hover:underline hover:underline-offset-4",
  imageHover: "transition-all duration-300 hover:scale-105 hover:rotate-1",
  
  // Animaciones compuestas
  fadeInSlideUp: "animate-fadeInSlideUp",
  popIn: "animate-popIn",
  
  // Delays
  delay100: "delay-100",
  delay200: "delay-200",
  delay300: "delay-300",
  delay400: "delay-400",
  delay500: "delay-500",
  
  // Utilidades
  smoothScroll: "scroll-smooth",
  smoothTransition: "transition-all duration-300 ease-in-out",

  // Nuevas animaciones modernas
  glassEffect: "backdrop-blur-sm bg-white/10 dark:bg-black/10",
  gradientText: "bg-gradient-to-r from-primary to-primary/80 bg-clip-text text-transparent",
  subtleGlow: "shadow-[0_0_15px_rgba(34,197,94,0.1)]",
  cardGlow: "hover:shadow-[0_0_20px_rgba(34,197,94,0.15)]",
  borderGlow: "border-primary/20 hover:border-primary/40",
  
  // Microinteracciones
  tapScale: "active:scale-95",
  hoverLift: "hover:-translate-y-1",
  hoverRotate: "hover:rotate-1",
  hoverBrightness: "hover:brightness-110",
  
  // Transiciones suaves
  smoothOpacity: "transition-opacity duration-300",
  smoothTransform: "transition-transform duration-300",
  smoothAll: "transition-all duration-300 ease-in-out",
  
  // Efectos de scroll
  parallax: "transform-gpu",
  sticky: "sticky top-0",
  
  // Efectos de texto
  textGradient: "bg-gradient-to-r from-primary to-primary/80 bg-clip-text text-transparent",
  textShadow: "text-shadow-lg",
  
  // Efectos de fondo
  gradientBg: "bg-gradient-to-br from-background to-background/80",
  noiseBg: "bg-noise",
  
  // Efectos de borde
  borderGradient: "border border-gradient-to-r from-primary to-primary/50",
  borderGlow: "border border-primary/20 hover:border-primary/40",
  
  // Efectos de hover avanzados
  hoverCard: "group hover:scale-[1.02] transition-all duration-300 hover:shadow-lg",
  hoverCardContent: "group-hover:scale-105 transition-transform duration-300",
  hoverCardOverlay: "group-hover:opacity-100 transition-opacity duration-300",
  
  // Efectos de carga
  skeleton: "animate-pulse bg-muted",
  shimmer: "animate-shimmer bg-gradient-to-r from-transparent via-primary/10 to-transparent",
  
  // Efectos de focus
  focusRing: "focus:ring-2 focus:ring-primary/50 focus:outline-none",
  focusScale: "focus:scale-[1.02] transition-transform duration-200",
  
  // Efectos de active
  activeScale: "active:scale-95 transition-transform duration-200",
  activeBrightness: "active:brightness-90 transition-all duration-200",
}; 